import {
  isOAuthAuthorizationNavigation,
  parseOAuthAuthorizationRequest,
} from './oauth-authorization';

const UTM_KEYS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
];
const SOURCE_PATTERN = /^[a-z0-9][a-z0-9_.-]{0,63}$/;
// Reject control characters before trimming attribution supplied in the URL.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;

const filterUtmParams = (value: unknown): Record<string, string> => {
  const result: Record<string, string> = {};
  if (!value || typeof value !== 'object' || Array.isArray(value)) return result;
  const params = value as Record<string, unknown>;
  UTM_KEYS.forEach(key => {
    const raw = params[key];
    if (typeof raw !== 'string' || CONTROL_CHARACTERS.test(raw)) return;
    const text = key === 'utm_source' ? raw.trim().toLowerCase() : raw.trim();
    if (!text || (key === 'utm_source' ? !SOURCE_PATTERN.test(text) : text.length > 256)) return;
    result[key] = text;
  });
  return result;
};

const getRegistrationAttribution = (
  search: string,
  stored: string | null = null,
  referrer = '',
) => {
  const params = new URLSearchParams(search);
  const isOAuth = isOAuthAuthorizationNavigation(search);
  const current: Record<string, string> = {};
  UTM_KEYS.forEach(key => {
    if (params.has(key)) current[key] = params.get(key) || '';
  });
  let cached: unknown = null;
  try {
    cached = JSON.parse(stored || '{}');
  } catch (_error) {
    // Ignore outdated or corrupt session attribution without blocking registration.
  }
  const utmParams = filterUtmParams(isOAuth || params.has('utm_source') ? current : {
    ...filterUtmParams(cached),
    ...current,
  });
  if (isOAuth && !utmParams.utm_source) utmParams.utm_source = 'oauth';
  const legacyFrom = referrer.includes('www.baidu.com') ? 'baidu' : params.get('from') || '';
  return {
    from: utmParams.utm_source || legacyFrom,
    utm_params: Object.keys(utmParams).length ? utmParams : null,
  };
};

// Keep OAuth continuation in the URL; only attribution belongs in registerQuery.
const buildAuthPagePath = (pathname: string, search: string) => {
  const params = new URLSearchParams();
  const request = parseOAuthAuthorizationRequest(search);
  if (request) {
    Object.entries(request).forEach(([key, value]) => params.set(key, value));
  }
  const { utm_params: utmParams } = getRegistrationAttribution(search);
  Object.entries(utmParams || {}).forEach(([key, value]) => params.set(key, value));
  const original = new URLSearchParams(search);
  ['from', 'activity_uuid', 'invite_code'].forEach(key => {
    const value = original.get(key);
    if (value) params.set(key, value);
  });
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export { buildAuthPagePath, getRegistrationAttribution };
